"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEndpoint = exports.getData = exports.getHeaders = void 0;
const axios_1 = require("axios");
let CancelToken = axios_1.default.CancelToken;
let source = CancelToken.source();
const cancelRequest = () => {
    // Cancel Request
    source.cancel();
    // Create New Token for the future request
    CancelToken = axios_1.default.CancelToken;
    source = CancelToken.source();
};
const getHeaders = () => __awaiter(void 0, void 0, void 0, function* () {
    const headerHandler = (e, resolve, ref) => {
        var _a;
        if (((_a = e.data) === null || _a === void 0 ? void 0 : _a.type) === "SetAuthHeaders") {
            // Resolve the promise
            window.removeEventListener("message", ref);
            resolve(e.data.payload);
            // Remove event listner
        }
    };
    // Send the post message to get auth headers)
    window.postMessage({ type: "GetAuthHeaders" }, "*");
    return new Promise((resolve, reject) => {
        // Create a referance for that function in order to remove the event listener
        let ref = (e) => headerHandler(e, resolve, ref);
        console.log("%c...waiting for auth headers", "color: #135db1");
        // Add event listener to get SetAuthHeaders
        window.addEventListener("message", ref);
    });
});
exports.getHeaders = getHeaders;
const getData = (src, config = {}) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let headers = {};
        if (config.requiresHeaders) {
            headers = yield (0, exports.getHeaders)();
        }
        if (config.cancelabe)
            cancelRequest();
        const { data, status } = yield axios_1.default.get(src, { headers, cancelToken: source.token });
        if (status === 200) {
            return { data, error: null };
        }
        else {
            if (data.error)
                throw new Error(data.error);
            throw new Error(`Failed to fetch, status: ${status}`);
        }
    }
    catch (error) {
        return { data: null, error };
    }
});
exports.getData = getData;
const getEndpoint = (baseUrl, endpoint, params) => {
    let url = new URL(endpoint, baseUrl);
    if (params) {
        for (const [key, value] of Object.entries(params)) {
            url.searchParams.append(key, value);
        }
    }
    return url.toString();
};
exports.getEndpoint = getEndpoint;
